(function () {
  var popupSelector = '.section-exit-pop.section-pop-common-festival';

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  }

  function hasReferralCandyParam() {
    var params = new URLSearchParams(window.location.search);
    return Array.from(params.values()).some(function (value) {
      return typeof value === 'string' && value.toLowerCase().indexOf('referralcandy') !== -1;
    });
  }

  function setTabOrientation(tablist) {
    if (!tablist) {
      return;
    }
    var vertical = window.matchMedia('(min-width: 901px)').matches;
    tablist.setAttribute('aria-orientation', vertical ? 'vertical' : 'horizontal');
  }

  function activatePanel(pop, panelId) {
    var tabs = pop.querySelectorAll('.section-pop-common-festival__tab');
    var panels = pop.querySelectorAll('.section-pop-common-festival__panel');

    tabs.forEach(function (tab) {
      var selected = tab.getAttribute('data-panel') === panelId;
      tab.classList.toggle('is-active', selected);
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      var selected = panel.getAttribute('data-panel') === panelId;
      panel.classList.toggle('is-active', selected);
      if (selected) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function initExitPopCommonFestival() {
    var pop = document.querySelector(popupSelector);
    if (!pop || pop.getAttribute('data-pop-ready') === 'true') {
      return;
    }

    if (hasReferralCandyParam()) {
      pop.remove();
      return;
    }

    var cookieName = pop.getAttribute('data-cookie-name') || 'exit_pop_close_one_day_spdpre_autumn';
    if (getCookie(cookieName) === 'true') {
      return;
    }

    pop.setAttribute('data-pop-ready', 'true');

    var closeBtn = pop.querySelector('.section-pop-common-festival__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setCookie(cookieName, 'true', 1);
        pop.classList.remove('active');
        pop.classList.remove('is-open');
      });
    }

    var tablist = pop.querySelector('.section-pop-common-festival__tabs');
    setTabOrientation(tablist);
    window.addEventListener('resize', function () {
      setTabOrientation(tablist);
    });

    pop.addEventListener('click', function (event) {
      var tab = event.target.closest('.section-pop-common-festival__tab');
      if (tab && pop.contains(tab)) {
        activatePanel(pop, tab.getAttribute('data-panel'));
        return;
      }

      var button = event.target.closest('.section-pop-common-festival__button');
      if (!button || !pop.contains(button)) {
        return;
      }

      var panel = button.closest('.section-pop-common-festival__panel');
      var popupName = panel ? panel.getAttribute('data-tracking-name') : '';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'pop_up',
        event_parameters: {
          popup_name: popupName || '',
          button_name: button.textContent.trim(),
        },
      });
    });

    pop.classList.add('is-open');
    window.setTimeout(function () {
      pop.classList.add('active');
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExitPopCommonFestival);
  } else {
    initExitPopCommonFestival();
  }
})();
